module.exports = __webpack_public_path__ + "static/brush-purple-7725ed69a44fc64c9e4cae0de22b5bef.png";